import userStore from '../store/modules/user.module';

	// alert(userStore.state.user);
export default {
	computed: {
	  authUser: function () {
	    return userStore.state.user;
	  },
	  investmentData: function () {
	    return userStore.state.investment_data;
	  },
	  CategoryListData: function () {
	    return userStore.state.category_list;
	  },
	  MemberListData: function () {
	    return userStore.state.member_list;
	  },
	  ReferralListData: function () {
	    return userStore.state.referral_list;
	  },
	  CurrentCategoryIdData: function () {
	    return userStore.state.current_category_id;
	  }, 
	  CurrentMutualFundData: function () {
	    return userStore.state.mutual_fund_data;
	  }
		,
	  CurrentShowAddFamilyMemberData: function () {
	    return userStore.state.show_add_family_member_button;
	  }
	  
	},
	methods: {
	    updateAuthUser: function (userAction, userData) {
		    return userStore.dispatch(userAction, userData);
		},
		singleUpdateAuthUser: function (userAction, userData) {
		    return userStore.dispatch(userAction, userData);
		},
		resetUser: function () {
		   return window.localStorage.clear();
		},
		updateInvestmentData: function (userAction, userData) {
		    return userStore.dispatch(userAction, userData);
		},
		updateCategoryListData: function (userAction, userData) {
		    return userStore.dispatch(userAction, userData);
		},
		updateMemberListData: function (userAction, userData) {
		    return userStore.dispatch(userAction, userData);
		},
		updateReferralListData: function (userAction, userData) {
		    return userStore.dispatch(userAction, userData);
		},
		updateCurrentCategoryIdData: function (userAction, userData) {
		    return userStore.dispatch(userAction, userData);
		},
		updateCurrentMutualFundData: function (userAction, userData) {
		    return userStore.dispatch(userAction, userData);
		},
		UpdateShowAddFamilyMemberData: function (userAction, userData) {
		    return userStore.dispatch(userAction, userData);
		}
	  }
}